import React, { useEffect, useRef } from 'react';
import { playGift, GIFT_MAP } from '../giftAnimations';

/*
  GiftStage — a transparent overlay that plays gift animations on top of the
  live video. Render ONE inside each live video container (broadcaster page AND
  viewer page); the container must be position:relative. It listens for a global
  'gems:gift' event so it works no matter which page/component received the
  WebSocket message. Gifts queue so back-to-back sends don't overlap.

  To trigger a gift from anywhere:
    window.dispatchEvent(new CustomEvent('gems:gift',
      { detail: { giftId: 'dragon', qty: 1, sender: 'Shoppa' } }));
*/
export default function GiftStage() {
  const stageRef = useRef(null);
  const capRef = useRef(null);
  const queue = useRef([]);
  const busy = useRef(false);

  useEffect(() => {
    const onGift = (e) => { queue.current.push(e.detail || {}); pump(); };
    window.addEventListener('gems:gift', onGift);
    return () => window.removeEventListener('gems:gift', onGift);
  }, []);

  function pump() {
    if (busy.current || !queue.current.length || !stageRef.current) return;
    busy.current = true;
    const { giftId, qty = 1, sender } = queue.current.shift();
    const g = playGift(stageRef.current, giftId, qty);
    if (capRef.current) {
      capRef.current.textContent = g
        ? `${sender || 'Someone'} sent ${g.name}${qty > 1 ? ` ×${qty.toLocaleString()}` : ''}`
        : '';
      capRef.current.style.opacity = g ? '1' : '0';
    }
    // Longest animation (Marry Me) runs ~7s; clear a touch after.
    setTimeout(() => {
      if (stageRef.current) stageRef.current.innerHTML = '';
      if (capRef.current) capRef.current.style.opacity = '0';
      busy.current = false;
      pump();
    }, 7200);
  }

  return (
    <div
      style={{ position: 'absolute', inset: 0, zIndex: 40, pointerEvents: 'none', overflow: 'hidden' }}
      aria-hidden="true"
      data-testid="gift-stage"
    >
      <div ref={stageRef} style={{ position: 'absolute', inset: 0 }} />
      <div
        ref={capRef}
        style={{
          position: 'absolute', left: 0, right: 0, bottom: '7%', textAlign: 'center',
          color: '#fff', fontWeight: 700, fontSize: '15px',
          textShadow: '0 2px 10px rgba(0,0,0,.75)', transition: 'opacity .3s', opacity: 0,
        }}
      />
    </div>
  );
}
